import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { adsAPI } from '@/utils/api';
import { AdPlaceholder } from '@/components/ads/AdPlaceholder';
import { AdMedia } from '@/components/ads/AdMedia';
import { AdRequestModal } from '@/components/ads/AdRequestModal';

// Banner ad space; renders nothing at all when the viewer is ad-free
export const AdSlot = ({ placement, className = '', vertical = false }) => {
  const location = useLocation();
  const [state, setState] = useState(null);
  const [requestOpen, setRequestOpen] = useState(false);

  useEffect(() => {
    let alive = true;
    adsAPI.serve(placement)
      .then((r) => alive && setState(r.data))
      .catch(() => alive && setState(null));
    return () => { alive = false; };
  }, [placement, location.pathname]);

  if (!state?.show) return null;

  return (
    <div className={className} data-testid={`ad-slot-${placement}`}>
      <div className="relative w-full h-full">
        {state.ad ? (
          <a
            href={state.ad.link_url}
            target="_blank"
            rel="noopener noreferrer sponsored"
            className="block w-full h-full rounded-lg overflow-hidden bg-black/40 border border-white/10"
            data-testid={`ad-link-${placement}`}
          >
            <AdMedia ad={state.ad} className="w-full h-full object-contain" />
          </a>
        ) : (
          <AdPlaceholder vertical={vertical} onClick={() => setRequestOpen(true)} testId={`ad-placeholder-${placement}`} />
        )}
        <span className="absolute top-1 right-1 px-1 rounded text-[9px] uppercase tracking-wider bg-black/60 text-gray-400 pointer-events-none">Ad</span>
      </div>
      <AdRequestModal open={requestOpen} onOpenChange={setRequestOpen} defaultType="banner" />
    </div>
  );
};

const HIDDEN_PREFIXES = ['/dm', '/groups', '/channels', '/chat', '/friends', '/profile', '/admin', '/login', '/register', '/owner'];

export const SiteAds = () => {
  const { pathname } = useLocation();
  if (HIDDEN_PREFIXES.some((p) => pathname.startsWith(p))) return null;
  return (
    <AdSlot placement="bottom" className="max-w-4xl mx-auto px-4 h-[64px] sm:h-[90px] mt-10 mb-6" />
  );
};
